import Auth from '@aws-amplify/auth';
import {
  Button,
  Container,
  Dimmer,
  Dropdown,
  Grid,
  Header,
  Label,
  Menu,
  Table,
  Icon,
  Item,
  Divider,
  Loader,
  Segment,
} from 'semantic-ui-react';
import { connect } from 'react-redux';

import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import moment from 'moment-timezone';
import { replace } from 'react-router-redux';
import { Link } from 'react-router';
import { flashErrorMessage } from '../../actions/flash';
import { decodeSearch, encodeSearch } from '../../utils/url';
import { getItem, setItem } from '../../utils/storage';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import PageNav from '../../components/PageNav';
import NavBar from '../../components/NavBar';
import ManageButton from '../../components/CreditCheckManageButton';
import CTOS_STATUSES from '../../constants/ctosStatus';

moment.locale('en-gb');

class Manage extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
  })
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      companyBranch: PropTypes.shape({
        shortName: PropTypes.string,
        isExternal: PropTypes.bool,
      }),
      isDeveloper: PropTypes.bool,
    }),
  }
  static getPropsToState = (props) => {
    const loading = true;
    const count = 0;
    const limit = 10;
    const offset = 0;
    const token = '';
    const hasMore = false;
    const hasLess = false;
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const reportToken = '';
    return {
      loading,
      token,
      count,
      limit,
      offset,
      hasMore,
      hasLess,
      currentPage,
      search,
      reportToken,
      noResultsMessage: 'Loading...',
      autoReload: false,
    };
  }
  constructor(props) {
    super(props);
    const state = Manage.getPropsToState(props);
    state.data = [];
    this.state = {
      ...state,
      ccrCreatorBUs: [],
      ccrProjects: [],
      companyAppCredit: [],
      companyApp: [],
      creditSubscription: {
        amount: 0,
      },
    };
  }

  componentDidMount() {
    const query = this.getQuery();
    this.fetchCreditReports(query);
    this.getCredit();
    const localAutoReloadValue = getItem(`${config.get('appName')}.creditCheckManageAutoReload`);
    if (localAutoReloadValue === 'true') {
      this.state.autoReload = true;
      this.setRefreshDataTimeout();
    }
    if (this.props.auth && this.props.auth.companyBranch) {
      this.getBUCreditsSubscription(this.props.auth.companyBranch);
    }
  }

  componentWillReceiveProps(nextProps) {
    const state = Manage.getPropsToState(nextProps);
    state.token = this.state.token;
    this.setState({ ...state });
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
  }

  getQuery(query = decodeSearch(this.props.location.search)) {
    return {
      businessUnit: query.businessUnit,
      page: this.state.currentPage,
      project: query.project,
      limit: this.state.limit,
      search: this.state.search,
      sortColumn: query.sortColumn,
      sortDirection: query.sortDirection,
      status: query.status,
    };
  }

  getBUCreditsSubscription = (companyBranch) => {
    const { store } = this.context;
    const id = companyBranch && companyBranch.service_company_branch_id;
    Auth.currentSession()
    .then((result) => {
      let creditsSubscriptionToken = (result).getIdToken().getJwtToken();
      if (config.get('server') === 'development') {
        creditsSubscriptionToken = config.get('subsAuth');
      }
      fetch(config.get('subscriptionApiEndpoint'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: creditsSubscriptionToken,
        },
        body: JSON.stringify({
          query: `
            query {
              getSubscription(
                id: "${id}",
              ) { ${this.getCreditsSubscriptionFragment()} }
            }
          `,
        }),
      })
      .then(async (res) => {
        if (res.ok) {
          const { data } = await res.json();
          if (data && data.getSubscription) {
            this.setState({
              creditSubscription: { ...data.getSubscription },
            });
          }
        } else {
          const message = 'Failed to retrieve subscription data';
          store.dispatch(flashErrorMessage(message));
        }
      });
    })
    .catch(err => store.dispatch(flashErrorMessage(err)));
  }

  getCreditsSubscriptionFragment = () => `
      id
      company_id
      company_branch_id
      amount
      currency_code
      created_at
      created_by
      updated_at
      updated_by
    `

  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  setRefreshDataTimeout = () => {
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
    this.timeoutRefresh = setTimeout(() => {
      this.handleRefreshData();
      this.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  }
  setData(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, res);
    });
  }
  async getCredit() {
    const { store } = this.context;
    await this.setLoading(true);
    let res;
    try {
      res = await store.dispatch(fetchM('/company/credit/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const companyAppCredit = await res.json();
      if (companyAppCredit !== null) {
        await this.setComponentState({ companyAppCredit, companyApp: companyAppCredit.companyApp });
      }
    }
    await this.setLoading(false);
  }
  async fetchCreditReports(query, silentLoad = false) {
    if (!silentLoad) {
      await this.setLoading(true);
    }
    const { store } = this.context;
    let res;
    try {
      const url = '/manage/credit_checks/';
      let queryString = '';
      if (qs.stringify(query)) {
        queryString = `?${qs.stringify(query)}`;
      }
      res = await store.dispatch(fetchM(`${url}${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      const hasLess = offset !== 0;
      let ccr = [];
      let ccrCreatorBUs = [
        { text: 'All', value: 'All' },
      ];
      let ccrProjects = [
        { text: 'All', value: 'All' },
      ];
      const result = await res.json();
      let hasMore;
      if (result) {
        if (result.businessUnits && result.businessUnits.length > 0) {
          for (let i = 0; i < result.businessUnits.length; i += 1) {
            ccrCreatorBUs = ccrCreatorBUs.concat({
              text: result.businessUnits[i],
              value: result.businessUnits[i],
            });
          }
        }
        if (result.projects && result.projects.length > 0) {
          for (let i = 0; i < result.projects.length; i += 1) {
            ccrProjects = ccrProjects.concat({
              text: result.projects[i],
              value: result.projects[i],
            });
          }
        }
        ccr = result.customerCreditReports ? result.customerCreditReports : [];
        hasMore = result.customerCreditReports && result.customerCreditReports.length === limit ? result.customerCreditReports.length !== count : false;
      } else {
        hasMore = false;
      }
      await this.setComponentState({
        token,
        count,
        limit,
        offset,
        data: ccr,
        hasMore,
        hasLess,
        ccrCreatorBUs,
        ccrProjects,
      });
    }
    await this.setLoading(false);
  }
  handleAutoReload = () => {
    const autoReload = !this.state.autoReload;
    this.setState({ autoReload }, () => {
      setItem(`${config.get('appName')}.creditCheckManageAutoReload`, autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        this.handleRefreshData();
        this.setRefreshDataTimeout();
      } else {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        if (this.timeoutRefresh) {
          clearTimeout(this.timeoutRefresh);
        }
      }
    });
  }
  handleRefreshData = () => {
    const query = decodeSearch(this.props.location.search);
    this.fetchCreditReports(query);
    this.getCredit();
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    }, () => {
      this.pushQuery();
    });
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = this.getQuery();
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      this.replaceQuery(query, true);
    }
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    store.dispatch(replace(`/customers/manage/credit_checks/?${encodeSearch(query)}`));
    this.fetchCreditReports(query, true);
  }
  pushQuery() {
    const query = this.getQuery();
    const { store } = this.context;
    store.dispatch(replace(`/customers/manage/credit_checks/?${encodeSearch(query)}`));
    this.fetchCreditReports(query);
  }

  sortItems = [
    {
      text: 'Oldest Credit report',
      icon: 'sort alphabet ascending',
      sortColumn: 'created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Latest Credit report',
      icon: 'sort alphabet descending',
      sortColumn: 'created_at',
      sortDirection: 'desc',
    },
    {
      text: 'Name Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'name',
      sortDirection: 'asc',
    },
    {
      text: 'Name Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'name',
      sortDirection: 'desc',
    },
  ];
  creditColor = (credit) => {
    let color;
    if (credit > 0) {
      if (credit <= 100) {
        color = 'mid';
      }
    } else {
      color = 'zero';
    }
    return color;
  }
  handleOnDropdownChange = (e, data) => {
    e.preventDefault();
    const { name, value } = data;
    const query = this.getQuery();

    query[name] = value;
    if (value === 'All') {
      query[name] = '';
    }

    this.replaceQuery(query, true);
  }
  renderPurchaser(data) {
    const { auth = {} } = this.props;
    const isAgent = auth.companyBranch ? auth.companyBranch.isExternal && auth.isDeveloper : false;
    if (!isAgent) {
      return (
        <Link to={`/customers/${data.customerID}/`}>
          {data.customer && data.customer.customerDetail &&
          data.customer.customerDetail !== null &&
          data.customer.customerDetail.name}
        </Link>
      );
    }
    if (data.booking && data.booking.id) {
      return (
        <Link to={`/bookings/${data.booking.id}/`}>
          {data.customer && data.customer.customerDetail &&
            data.customer.customerDetail !== null &&
            data.customer.customerDetail.name}
        </Link>
      );
    }

    return (
      <span>
        {data.customer && data.customer.customerDetail &&
      data.customer.customerDetail !== null &&
      data.customer.customerDetail.name}
      </span>
    );
  }
  render() {
    const { auth = {} } = this.props;
    const {
      creditSubscription,
      companyAppCredit,
    } = this.state;
    const isAgent = auth.companyBranch ? auth.companyBranch.isExternal && auth.isDeveloper : false;
    const isHQDeveloper = auth.isHeadquarters;
    const query = decodeSearch(this.props.location.search);
    return (
      <Container>
        <NavBar
          header={(this.state.count === 0) ? 'Manage' : <span>Manage &nbsp;<Label color="blue">{this.state.count}</Label></span>}
          rightNav={isHQDeveloper ?
            <Menu.Item fitted>
              <Button
                as={Link}
                primary
                content="Settings"
                disabled={this.state.loading}
                to={'/customers/manage/credit_checks/settings/'}
              />
            </Menu.Item> : null
          }
        />
        <Grid className="manage credit-check">
          <Grid.Row>
            <Grid.Column>
              <Dimmer
                active={this.state.loading &&
                  this.state.data &&
                  this.state.data.length > 0
                }
                inverted
              >
                <Loader inline="centered">Loading</Loader>
              </Dimmer>
              <Segment className="dark credit-check" color="grey" inverted secondary textAlign="center">
                <Divider horizontal inverted>Manage</Divider>
                {
                  !isAgent ? (
                    <Button
                      as={Link}
                      disabled={this.state.loading}
                      size="small"
                      color="blue"
                      content="Generate New Credit Check"
                      to={'/customers/new/'}
                    />
                  ) : null
                }
                <Header>
                  <Header.Content className="previous-credit-check">
                    <p style={{ fontSize: '.9em', margin: '0 0 .3em' }}>Credits</p>
                    <p
                      className={this.creditColor(creditSubscription.amount)}
                    >
                      MYR&nbsp;
                      {
                        creditSubscription.amount
                      }
                    </p>
                  </Header.Content>
                </Header>
                <Grid>
                  <Grid.Row only="computer">
                    <Grid.Column width={3}>
                      <PageNav
                        color="white"
                        currentPage={this.state.currentPage}
                        count={this.state.count}
                        limit={this.state.limit}
                        hasMore={this.state.hasMore}
                        hasLess={this.state.hasLess}
                        loading={this.state.loading}
                        onChange={this.handleChangePage}
                      />
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <SearchFilter
                        isLoading={this.state.loading}
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        search={this.state.search}
                        placeholder="Search"
                      />
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Dropdown
                        name="project"
                        placeholder="Project"
                        fluid
                        search
                        selection
                        onChange={this.handleOnDropdownChange}
                        options={this.state.ccrProjects}
                        value={query.project}
                      />
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Dropdown
                        name="businessUnit"
                        placeholder="Business unit"
                        fluid
                        search
                        selection
                        onChange={this.handleOnDropdownChange}
                        options={this.state.ccrCreatorBUs}
                        value={query.businessUnit}
                      />
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Dropdown
                        name="status"
                        placeholder="Status"
                        fluid
                        search
                        selection
                        onChange={this.handleOnDropdownChange}
                        options={CTOS_STATUSES}
                        value={query.status}
                      />
                    </Grid.Column>
                    <Grid.Column width={1}>
                      <SortButton
                        floated="right"
                        loading={this.state.loading}
                        items={this.sortItems}
                        onSort={this.handleSortData}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row only="tablet">
                    <Grid.Column width={3}>
                      <PageNav
                        color="white"
                        currentPage={this.state.currentPage}
                        count={this.state.count}
                        limit={this.state.limit}
                        hasMore={this.state.hasMore}
                        hasLess={this.state.hasLess}
                        loading={this.state.loading}
                        onChange={this.handleChangePage}
                      />
                    </Grid.Column>
                    <Grid.Column width={11}>
                      <SearchFilter
                        isLoading={this.state.loading}
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        search={this.state.search}
                        placeholder="Search"
                      />
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <SortButton
                        floated="right"
                        loading={this.state.loading}
                        items={this.sortItems}
                        onSort={this.handleSortData}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row only="tablet" columns={3}>
                    <Grid.Column>
                      <Dropdown
                        name="project"
                        placeholder="Project"
                        fluid
                        search
                        selection
                        onChange={this.handleOnDropdownChange}
                        options={this.state.ccrProjects}
                        value={query.project}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Dropdown
                        name="businessUnit"
                        placeholder="Business unit"
                        fluid
                        search
                        selection
                        onChange={this.handleOnDropdownChange}
                        options={this.state.ccrCreatorBUs}
                        value={query.businessUnit}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Dropdown
                        name="status"
                        placeholder="Status"
                        fluid
                        search
                        selection
                        onChange={this.handleOnDropdownChange}
                        options={CTOS_STATUSES}
                        value={query.status}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row only="mobile" columns={2}>
                    <Grid.Column textAlign="left">
                      <PageNav
                        color="white"
                        currentPage={this.state.currentPage}
                        count={this.state.count}
                        limit={this.state.limit}
                        hasMore={this.state.hasMore}
                        hasLess={this.state.hasLess}
                        loading={this.state.loading}
                        onChange={this.handleChangePage}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <SortButton
                        floated="right"
                        loading={this.state.loading}
                        items={this.sortItems}
                        onSort={this.handleSortData}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row only="mobile">
                    <Grid.Column>
                      <SearchFilter
                        isLoading={this.state.loading}
                        onChange={this.handleFilterOnChange}
                        onClose={this.handleClearFilter}
                        search={this.state.search}
                        placeholder="Search"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row only="mobile">
                    <Grid.Column>
                      <Dropdown
                        name="project"
                        placeholder="Project"
                        fluid
                        search
                        selection
                        onChange={this.handleOnDropdownChange}
                        options={this.state.ccrProjects}
                        value={query.project}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row only="mobile">
                    <Grid.Column>
                      <Dropdown
                        name="businessUnit"
                        placeholder="Business unit"
                        fluid
                        search
                        selection
                        onChange={this.handleOnDropdownChange}
                        options={this.state.ccrCreatorBUs}
                        value={query.businessUnit}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row only="mobile">
                    <Grid.Column>
                      <Dropdown
                        name="status"
                        placeholder="Status"
                        fluid
                        search
                        selection
                        onChange={this.handleOnDropdownChange}
                        options={CTOS_STATUSES}
                        value={query.status}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column textAlign="center" width={16}>
                      <Button
                        onClick={this.handleAutoReload}
                        compact
                        size="tiny"
                        icon={this.state.autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' }}
                        content={`Auto Refresh ${this.state.autoReload ? 'On' : 'Off'}`}
                      />
                      <Button
                        color="blue"
                        onClick={this.handleRefreshData}
                        compact
                        size="tiny"
                        icon="refresh"
                        content="Refresh Now"
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                {
                  this.state.data && this.state.data.length > 0 ?
                    <Grid columns={2} className="equal height">
                      <Grid.Row>
                        <Grid.Column width={16}>
                          <Table singleLine={false} columns={16} unstackable celled className="dark">
                            <Table.Header>
                              <Table.Row>
                                <Table.HeaderCell>Purchaser</Table.HeaderCell>
                                <Table.HeaderCell className="mobile-hide" textAlign="center">Project</Table.HeaderCell>
                                <Table.HeaderCell className="mobile-hide" textAlign="center">Business unit</Table.HeaderCell>
                                <Table.HeaderCell className="mobile-hide" textAlign="center">Requested by</Table.HeaderCell>
                                {
                                  !isAgent ? (
                                    <Table.HeaderCell className="mobile-hide" textAlign="center">Purchased by</Table.HeaderCell>
                                  ) : null
                                }
                                <Table.HeaderCell textAlign="center">CTOS Score</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">DSR Score</Table.HeaderCell>
                                <Table.HeaderCell className="mobile-hide" textAlign="center">Date</Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>
                            <Table.Body>
                              {
                                this.state.data.map((data, idx) => (
                                  <Table.Row
                                    key={idx}
                                    id={data.id}
                                    positive={data.approve}
                                    negative={data.decline}
                                  >
                                    <Table.Cell>
                                      {
                                        this.renderPurchaser(data)
                                      }
                                    </Table.Cell>
                                    <Table.Cell textAlign="center">
                                      {
                                        data.projectName !== '' ?
                                          data.projectName :
                                          <Icon color="grey" name="minus" />
                                      }
                                    </Table.Cell>
                                    <Table.Cell textAlign="center">
                                      {
                                        data.maUserAffiliateCompanyBranchName !== '' ?
                                          data.maUserAffiliateCompanyBranchName :
                                          <Icon color="grey" name="minus" />
                                      }
                                    </Table.Cell>
                                    <Table.Cell className="mobile-hide" textAlign="center">
                                      {
                                        data.maUserSubmittedByPreferredName !== '' ?
                                          data.maUserSubmittedByPreferredName :
                                          <Icon color="grey" name="minus" />
                                      }
                                    </Table.Cell>
                                    {
                                      !isAgent ? (
                                        <Table.Cell className="mobile-hide" textAlign="center">
                                          {data.maUserPurchasedByPreferredName !== '' ?
                                            data.maUserPurchasedByPreferredName :
                                            <Icon color="grey" name="minus" />
                                          }
                                        </Table.Cell>
                                      ) : null
                                    }
                                    {
                                      data.mCtosXMLStatusID === 'dsr_generated' ?
                                        <Table.Cell textAlign="center" collapsing>
                                          {data.ctosScore}
                                        </Table.Cell> :
                                      null
                                    }
                                    {
                                      data.mCtosXMLStatusID === 'dsr_generated' ?
                                        <Table.Cell textAlign="center" collapsing>
                                          {
                                            data.mCtosXMLStatusID === 'dsr_generated' ?
                                              `${data.dsr} %` :
                                              ''
                                          }
                                        </Table.Cell> :
                                        <Table.Cell colSpan="2" textAlign="center">
                                          <ManageButton
                                            data={data}
                                            index={idx}
                                            fetchCreditReports={this.fetchCreditReports}
                                            getQuery={
                                            this.getQuery(
                                                decodeSearch(this.props.location.search))
                                            }
                                            // companyApp={companyApp}
                                            companyAppCredit={companyAppCredit}
                                            handleOpenModal={this.handleOpenModal}
                                            isAgent={isAgent}
                                            creditsAmount={creditSubscription && creditSubscription.amount !== '' ? Number(creditSubscription.amount) : 0}
                                          />
                                        </Table.Cell>
                                    }
                                    <Table.Cell className="mobile-hide" textAlign="center">
                                      {
                                        data.createdAt !== '' ?
                                          moment(data.createdAt).format('DD/MM/YY') :
                                          <Icon color="grey" name="minus" />
                                      }
                                    </Table.Cell>
                                  </Table.Row>
                                ))
                              }
                            </Table.Body>
                          </Table>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column textAlign="center" width={16}>
                          <PageNav
                            color="white"
                            currentPage={this.state.currentPage}
                            count={this.state.count}
                            limit={this.state.limit}
                            hasMore={this.state.hasMore}
                            hasLess={this.state.hasLess}
                            loading={this.state.loading}
                            onChange={this.handleChangePage}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  : (
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <Item style={{}}>
                            <Item.Content>
                              {
                              !this.state.loading ?
                                <Segment textAlign="center">
                                  <p>No pending Credit checks found.</p>
                                </Segment>
                              : ''
                              }
                            </Item.Content>
                          </Item>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  )
                }
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default connect(Manage.mapStateToProps)(Manage);



// WEBPACK FOOTER //
// ./src/containers/CreditCheck/Manage.jsx